import { ThemeToggle, ThemeProvider } from '@/lib/ThemeProvider';
import { Button } from "@/components/ui/button";
import { Coffee, Timer, CheckCircle2, ArrowRight } from 'lucide-react';

export const MaintenancePage = () => {

  return (
    <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center p-4">
        <div className="max-w-2xl w-full">
          {/* Header com Logo */}
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center gap-3">
              <img
                src="https://app.thenewscc.com.br/thenews.webp"
                alt="Logo"
                className="w-32 rounded-lg"
              />
            </div>
            <ThemeToggle />
          </div>

          {/* Card Principal */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 md:p-8 shadow-sm border border-gray-200 dark:border-gray-700">
            {/* Ícone de Manutenção */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-[#FFD000]/10 rounded-full flex items-center justify-center">
                <Timer className="w-8 h-8 text-[#FFD000]" />
              </div>
            </div>

            {/* Título e Subtítulo */}
            <div className="text-center mb-8">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-[#FFD000] mb-4">
                estamos em manutenção 🛠️
              </h1>
              <p className="text-gray-600 dark:text-gray-400 text-lg">
                calma, seu streak está seguro! 
              </p>
            </div>

            {/* Informações Detalhadas */}
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#FFD000]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <CheckCircle2 className="w-4 h-4 text-[#FFD000]" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 dark:text-white mb-1">
                    seu streak está preservado
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    não se preocupe, todas as leituras deste período serão contabilizadas automaticamente assim que voltarmos
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#FFD000]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Coffee className="w-4 h-4 text-[#FFD000]" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 dark:text-white mb-1">
                    enquanto isso...
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    que tal pegar um café? voltaremos em breve ☕
                  </p>
                </div>
              </div>
            </div>

            {/* Botão de Ação */}
            <div className="flex flex-col items-center gap-4">
              <Button
                onClick={() => window.location.href = 'https://thenewscc.beehiiv.com'}
                className="w-full py-6 bg-[#FFD000] hover:bg-[#FFE14D] text-gray-900 rounded-xl font-bold text-lg
                  transform hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
              >
                continuar lendo
                <ArrowRight className="w-5 h-5" />
              </Button>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                você será notificado assim que voltarmos
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-8">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              © 2026 the news. você mais inteligente em 5 minutos ✨
            </p>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}; 